// extracted by mini-css-extract-plugin
module.exports = {"merch-card-wrapper":"TourCardSliderContent_merch-card-wrapper__G681p"};